import { InvalidUrlError } from '../../../common/errors/errors';
import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { ModelType } from '../../../common/utils/GQLIdEncoder';
import { ReportMapper } from '../mappers/ReportMapper';
import { Report } from '../models/Report';

export const GET_REPORT_QUERY = `
query($id: ID!) {
  report: node(id: $id) {
    __typename
    ... on Report {
      id
      name
      createdAt
      ruleset
      traceType
      trace {
        id
        name
        size
      }
      profile {
        id
        name
        type
      }
      slot {
        id
        name
        reports {
          edges {
            node {
              id
              name
              createdAt
              ruleset
            }
          }
        }
        project {
          id
          name
        }
      }
    }
    ... on ReportDone {
      completedAt
      rules(includeDisabledRules: true, includeFilteredRules: true) {
        totalCount
      }
      keys {
        totalCount
      }
      certificates {
        totalCount
      }
      handshakes {
        totalCount
      }
      sshHandshakes {
        totalCount
      }
      ciphersuites {
        nid
      }
      operations {
        totalCount
      }
      nonsensitiveSalt
      coverageSummary {
        total
        covered
        depth
      }
      callLimiting {
        callsLimited
        maxCallsPerBucket
        maxCallsTotal
        numCallsKept
        numCallsOverBucketLimit
        numCallsOverTotalLimit
        numCallsTotal
        numBuckets
        numFullBuckets
      }
    }
    ... on ReportFailed {
      reason
    }
  }
}`;

export class ReportRepository extends BaseGQLService {
  private readonly mapper = new ReportMapper();

  async getReport(reportId: number): Promise<Report> {
    return this.query(
      GET_REPORT_QUERY,
      {
        id: this.gqlIdEncoder.encode(ModelType.Report, reportId),
      },
      (data) => {
        if (!data.report) {
          throw new InvalidUrlError(`Invalid request: could not find Report ${reportId}`);
        }
        return this.mapper.mapGQLModel(data.report);
      }
    );
  }
}
